import { render, staticRenderFns } from "./TitleDetailSideInfos.vue?vue&type=template&id=c854ca9a&scoped=true"
import script from "./TitleDetailSideInfos.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDetailSideInfos.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleDetailSideInfos.vue?vue&type=style&index=0&id=c854ca9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c854ca9a",
  null
  
)

export default component.exports